import React, { Fragment } from 'react';
import { Button, Card, Col, Row } from 'reactstrap';
import { usePatients } from '../../../hooks/patients/usePatients';
import { ModalPatient } from '../../../components/patients/ModalPatient';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { Dialog } from 'primereact/dialog';
import { DialogTransferPatient } from './DialogTransferPatient';


export const IndexPatient = () => {

    const {
        // ? ACTIONS OF THE MODAL
        modal, modalTitle, method, loading, toggle,

        // ? MODELS
        isInvoiceService, setIsInvoiceService, viewNewSocialGender, setViewNewSocialGender,

        // ? CATALOGS
        listPatients, listStates, listMunicipalities, listBloodType,
        listTaxRegime, listUseCfdi, listSocialGender,

        // ? FIELD
        id_gender, id_state, id_municipality, id_blood_type, id_social_gender, id_tax_regime,
        id_use_cfdi, rfc, type_person, code, paternal_surname, maternal_surname, name, birthday, age,
        curp, address, cp, colony, phone, email, membership, cardnumber, new_social_gender, handleDateB,
        getAge, matricula_buap, nss, expedient_number,

        // ? ACTIONS OF THE INPUTS
        handleInputChange, handleSelectValues, handleDate, handleSearch, handleCreate, handleChangeState,
        handleChangeTypePerson, handleChangeTaxRegime,
        handleUpdate, handleDelete, handleChangeSocialGender,

        // ? SAVE METHODS
        saveCreatePatient, saveDelete, saveUpdatePatient,

        // ? PAGINATION AND FILTER TABLE
        goToPage, actualPage, totalRecords,
        exportExcelPatient, loadingExport, closeModalPatient, searchQuery, handleClearFilter,

        // ? DYNAMIC FORM
        listConfiguration, fieldErrors,


        // ? CONFIGURATION 
        handleViewPatient, modalviewHistoric, dataInfo, toggleHistoric, loadingView, labelPatient, validateWhatsapp, handleWhatsappChange, whatsapp_numbers,

        handleWhatsappDoctorChange, validateWhatsappDoctor, showConfirm, modalTransfer, handleCreateTransferPatient, closeTransferPatient, setShowConfirm,
        setIsPatientSelected, isPatientSelected, setSearchPatientState, searchPatientState, formValuesPatient, 
        handleSelectChangePatient,searchKey, setSearchKey, handleShowConfirmPatient, getWorkOrderPatientCount, handleTransferPatient, 
        errorTransferPatient, workOrderPatientCount,namePatientDestination, namePatientOrigin,
        setSearchPatientDestination, searchPatientDestination, setSearchPatientOrigin, searchPatientOrigin,
        setWorkOrderPatientCount, loadingCount




    } = usePatients();

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_patient)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_patient)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>



                <button
                    type="button"
                    onClick={() =>
                        handleViewPatient(
                            rowData.id_patient,
                            `${rowData.name} ${rowData.paternal_surname} ${rowData.maternal_surname}`
                        )
                    } style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ff9800",
                        border: '#FF9800',
                        color: "#ffff"
                    }}
                    title="Historial demografico"
                >
                    <i className="pi pi-user-edit" />
                </button>

            </div>
        );
    };




    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const rowsPerPage = 10
    
    let _transferPatient = localStorage.getItem('configuration_patient');


    return (
        <Fragment>
            <div className='container-global-zoom' >
                <Row >

                    <Col sm="12" md="12" lg="12">
                        <Card>
                            <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                                <TitleDataTable
                                    titleTable="Listado de pacientes"
                                    buttonActions={exportExcelPatient}
                                    titleButton="Descargar listado de pacientes"
                                    isDisbled={loadingExport}
                                    loadingIsDisabled={loadingExport}
                                    titleCreate="Crear Paciente"
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearch}
                                    valueFilter={searchQuery}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearFilter}
                                   
                                     {...(_transferPatient === "True" && {
                                        tranferButton: true,
                                        titleButtonTransfire: "Homologar Pacientes",
                                        buttonTransfire: handleCreateTransferPatient

                                    })}
                                />

                                
                            </Col>

                            <Row>
                                <Col sm="12" md="12" lg="12">

                                    <div style={{ overflowX: "auto", scrollBehavior: "smooth", padding: "0" }}>
                                        <DataTable
                                            value={listPatients}
                                            lazy
                                            paginator
                                            first={(actualPage - 1) * rowsPerPage}
                                            rows={rowsPerPage}
                                            totalRecords={totalRecords}
                                            onPage={(e) => goToPage(e.page + 1)}
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            responsiveLayout="scroll"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="paternal_surname" header="Apellido paterno" headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="maternal_surname" header="Apellido materno" headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="name_gender" header="Género" headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="birthday" header="F. Nacimiento" headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="age" header="Edad" headerStyle={headerStyle} style={centerStyle} />
                                            {/* <Column field="email" header="Correo" headerStyle={headerStyle} style={centerStyle} /> */}
                                            <Column field="phone" header="Télefono" headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="curp" header="Curp" headerStyle={headerStyle} style={centerStyle} />
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                        </DataTable>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

            </div>
            <br /><br />
            <ModalPatient
                {
                ...{
                    modal, toggle, modalTitle, method, loading,
                    getAge,

                    handleInputChange, handleSelectValues, handleDate,

                    id_gender, id_state, id_municipality, id_blood_type, id_social_gender, id_tax_regime,
                    id_use_cfdi, rfc, type_person, code, paternal_surname, maternal_surname, name, birthday,
                    curp, address, cp, colony, phone, email, membership, cardnumber, new_social_gender,
                    listStates, listMunicipalities, listBloodType, listTaxRegime, listUseCfdi,
                    listSocialGender,
                    handleChangeState, handleChangeTypePerson, handleChangeTaxRegime, handleChangeSocialGender,

                    saveDelete,

                    isInvoiceService, setIsInvoiceService, viewNewSocialGender, setViewNewSocialGender,
                    handleDateB, age,

                    savePatient: saveCreatePatient, saveUpdate: saveUpdatePatient,

                    closeModalPatient, listConfiguration, fieldErrors, matricula_buap, nss, expedient_number,
                    handleWhatsappChange, validateWhatsapp, whatsapp_numbers, handleWhatsappDoctorChange, validateWhatsappDoctor

                }
                }
            />
            {
                // ? HISTORIC
            }
            <Dialog
                header={<label className='f-w-600'>Historico</label>}
                visible={modalviewHistoric}
                onHide={toggleHistoric}
                modal
                stripedRows
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                    content: { style: { paddingLeft: "1px" } }
                }}
                footer={
                    <Button
                        color="danger text-center"
                        type="button"
                        onClick={toggleHistoric}
                        disabled={loadingView}
                    >
                        Cancelar
                    </Button>
                }
            >
                <Col sm="12" className='pb-3 pt-1 p-l-0 p-r-0'>
                    <Col sm="12" className='pb-3 p-l-0  p-r-0' >
                        <div
                            style={{
                                background: "#ff9800",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
                                marginBottom: "14px",
                                padding: "14px 18px"
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>

                                <div
                                    style={{
                                        backgroundColor: "rgba(255,255,255,0.25)",
                                        width: "38px",
                                        height: "38px",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <i
                                        className="pi pi-history"
                                        style={{
                                            color: "#ffffff",
                                            fontSize: "1.1rem"
                                        }}
                                    />
                                </div>

                                <div>
                                    <div
                                        style={{
                                            color: "#ffffff",
                                            fontWeight: 600,
                                            fontSize: "0.95rem",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Historial de cambios del paciente
                                    </div>

                                    <div
                                        style={{
                                            color: "rgba(255,255,255,0.85)",
                                            fontSize: "0.78rem",
                                            marginTop: "2px"
                                        }}
                                    >
                                        {labelPatient ?? "---"}
                                    </div>
                                </div>
                            </div>

                            <div
                                style={{
                                    backgroundColor: "rgba(255,255,255,0.25)",
                                    padding: "6px 12px",
                                    borderRadius: "20px",
                                    fontSize: "0.75rem",
                                    fontWeight: 500,
                                    color: "#ffffff"
                                }}
                            >
                                {dataInfo?.length ?? 0} movimientos
                            </div>
                        </div>
                    </Col>
                    <DataTable
                        value={dataInfo}
                        dataKey="created_information"
                        paginator
                        rows={10}
                        stripedRows
                        showGridlines
                        className="p-datatable-sm"

                        rowsPerPageOptions={[10, 50, 100, 200]}
                        responsiveLayout="scroll"
                        emptyMessage={
                            <div className="text-center">
                                <img
                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                    style={{ width: "35%" }}
                                    alt="Sin resultados"
                                />
                                <br />
                                {
                                    !loadingView && <p className="badge badge-light-primary mt-2" style={{ fontSize: "12px" }}>
                                        No hay historial de movimientos del paciente.
                                    </p>
                                }
                                {
                                    loadingView && <p className="badge badge-light-primary mt-2" style={{ fontSize: "12px" }}>
                                        Cargando información.....
                                    </p>

                                }

                            </div>
                        }
                    >
                        <Column
                            header="#"
                            body={(row, { rowIndex }) => rowIndex + 1}
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />

                        <Column
                            field="created_information"
                            header="Fecha"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />
                        <Column
                            field="method"
                            header="Acción"
                            headerStyle={headerStyle}
                            style={centerStyle}
                            body={(rowData) => (
                                <span
                                    style={{
                                        padding: "4px 8px",
                                        borderRadius: "20px",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        backgroundColor:
                                            rowData.method === "ACTUALIZAR"
                                                ? "#fff3cd"
                                                : "#d4edda",
                                        color:
                                            rowData.method === "ACTUALIZAR"
                                                ? "#856404"
                                                : "#155724"
                                    }}
                                >
                                    {rowData.method}
                                </span>
                            )}
                            sortable
                        />
                        <Column
                            field="name_user"
                            header="Usuario que modifico"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />
                        <Column
                            field="site"
                            header="Módulo"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />
                        <Column
                            field="field_name"
                            header="Campo"
                            sortable
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />
                        <Column
                            field="original_information"
                            header="Valor Anterior"
                            body={(rowData) => (
                                <span style={{ color: "#6c757d" }}>
                                    {rowData.original_information}
                                </span>
                            )}
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />

                        <Column
                            field="updated_information"
                            header="Valor Nuevo"
                            body={(rowData) => (
                                <span style={{ fontWeight: 600, color: "#1e88e5" }}>
                                    {rowData.updated_information}
                                </span>
                            )}
                            headerStyle={headerStyle}
                            style={centerStyle}
                        />
                    </DataTable>
                </Col>
            </Dialog >

            {
                //? TRANSFER PATIENT WORK ORDER

                <DialogTransferPatient
                    {
                    ...{
                        modalTransfer, closeTransferPatient,
                        handleInputChange,
                        handleCreateTransferPatient,
                        showConfirm, setShowConfirm,
                        setIsPatientSelected, isPatientSelected, setSearchPatientState, searchPatientState, formValuesPatient, handleSelectChangePatient,
                        searchKey,setSearchKey,

                        handleShowConfirmPatient, getWorkOrderPatientCount, handleTransferPatient,
                        errorTransferPatient, workOrderPatientCount,namePatientDestination, namePatientOrigin,
                        setSearchPatientDestination, searchPatientDestination, setSearchPatientOrigin, searchPatientOrigin,
                        setWorkOrderPatientCount, loadingCount



            
                    }
                    }
                    
                />
            }
        </Fragment >
    )
}
